// @ts-nocheck
(function () {
  var BOT_PATTERN = '(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';

  function isBot() {
    return new RegExp(BOT_PATTERN, 'i').test(navigator.userAgent);
  }

  function mainOrigin() {
    var h = window.location.hostname;
    if (h === 'ads.powdervalley.com') return 'https://www.powdervalley.com';
    if (h === 'ads-qa.powdervalley.com') return 'https://powdervalley.myshopify.com';
    if (h.startsWith('ads-') && h.endsWith('.powdervalley.com')) {
      return 'https://powdervalley.myshopify.com';
    }
    return 'https://powdervalley.myshopify.com';
  }

  var MAIN_CART_URL = mainOrigin() + '/cart';

  // ── Detect traffic source and store it once per session ─────────────────
  var SOURCE_KEY = 'pv_ads_source';
  var THRESHOLDS = { facebook: 1, google: 2, unknown: 2 };

  function detectSource() {
    var params = new URLSearchParams(window.location.search);
    var src    = (params.get('utm_source')  || '').toLowerCase();
    var medium = (params.get('utm_medium')  || '').toLowerCase();
    if (/facebook|fb|instagram|meta/.test(src) || /paid_social|social/.test(medium)) return 'facebook';
    if (/google/.test(src) || /cpc|ppc|paid_search/.test(medium))                    return 'google';
    return 'unknown';
  }

  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('utm_source') || urlParams.get('utm_medium')) {
    // UTM present on this page — always update so the landing ad wins
    localStorage.setItem(SOURCE_KEY, detectSource());
  } else if (!localStorage.getItem(SOURCE_KEY)) {
    localStorage.setItem(SOURCE_KEY, detectSource());
  }
  var source    = localStorage.getItem(SOURCE_KEY);
  var threshold = THRESHOLDS[source] || 2;

  // ── Ad-funnel bridge pages ──────────────────────────────────────────────
  // The ad funnel is: ad → bridge page → ppc landing page → real browsing.
  // The bridge → ppc hop is a real link click, but it must NOT count toward the
  // browse limit (otherwise facebook's 1-click limit would bounce the visitor on
  // that hop, before they ever reach the ppc landing). So any click made while ON
  // a bridge page is ignored by the counter; counting begins on the ppc landing
  // page and everything after it. Add more bridge paths here if campaigns use them.
  var BRIDGE_PATHS = ['/pages/offers'];
  function onBridgePage() {
    return BRIDGE_PATHS.indexOf(window.location.pathname) !== -1;
  }

  // ── Shared transfer loader (pv-cart-transfer-overlay) ────────────────────
  function showTransferOverlay() {
    var docEl = document.documentElement;
    docEl.setAttribute('data-pv-cart-transfer', '');
    setTimeout(function () { docEl.removeAttribute('data-pv-cart-transfer'); }, 8000);
  }

  // ── Cross-domain handoff ─────────────────────────────────────────────────
  // Sends the visitor to the main domain at `destUrl`. If the ads cart has items
  // they are merged into the main cart (cleared on ads, re-added by
  // pv-ads-cart-receive.js on the destination page); otherwise we just navigate.
  // The cart icon passes the main /cart URL; the browse-limit bounce passes the
  // same page on the main domain, so a browsing user is NOT dumped on /cart.
  function buildItems(cart) {
    return (cart.items || []).map(function (item) {
      var out = { id: item.variant_id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) {
        out.properties = item.properties;
      }
      var sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
      if (sp && sp.id) out.selling_plan = sp.id;
      return out;
    });
  }

  function goToMainWithCart(destUrl, openDrawer) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          window.location.href = destUrl; // nothing to merge
          return;
        }
        showTransferOverlay();
        // Payload carries the items plus whether the main domain should open the
        // cart drawer on arrival (only set for the add-to-cart hop).
        var payload = encodeURIComponent(JSON.stringify({
          items: buildItems(cart),
          drawer: !!openDrawer
        }));
        // Clear the ads cart, then navigate. The payload (not the ads cart) is
        // the source of truth for the main-domain add, so clearing first is safe.
        return fetch('/cart/clear.js', { method: 'POST' })
          .catch(function () {})
          .then(function () { window.location.href = destUrl + '#pv_cart=' + payload; });
      })
      .catch(function () { window.location.href = destUrl; });
  }

  // Shared with algolia_custom_hooks.js, whose capture-phase counter hands off
  // the same way when a product-card click crosses the browse limit.
  window.pvAdsGoToMain = goToMainWithCart;

  // ── Route guards ─────────────────────────────────────────────────────────
  // No account, cart, or checkout pages on the ads domain. A direct hit on the
  // ads /cart is sent to the MAIN cart, carrying any ads-cart items, so a visitor
  // who lands there by URL ends up where they can actually check out. Account and
  // checkout just go home.
  var path = window.location.pathname;
  if (/^\/cart/.test(path)) {
    goToMainWithCart(MAIN_CART_URL);
  } else if (/^\/(account|customer_authentication|checkouts?)/.test(path)) {
    window.location.replace('/');
  }

  // ── Cart-icon lock ───────────────────────────────────────────────────────
  // The cart icon is the exit to the main store. It stays locked only while the
  // ads cart is EMPTY; the moment there is at least one item it unlocks and hands
  // off to the main cart. (The cart bubble shows the theme's native ads count.)
  var pvAdsCartHasItems = false;

  function applyCartLinks() {
    var locked = !pvAdsCartHasItems;
    var links = document.querySelectorAll('[data-pv-ads-cart]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('href') !== MAIN_CART_URL) {
        link.setAttribute('href', MAIN_CART_URL);
      }
      link.setAttribute('aria-disabled', locked ? 'true' : 'false');
      link.classList.toggle('pv-cart-link--disabled', locked);
    }
  }

  // The ads cart persists across ads pages, so check on load whether it already
  // holds items and unlock the icon accordingly.
  function refreshCartState() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        pvAdsCartHasItems = !!(cart && cart.item_count);
        applyCartLinks();
      })
      .catch(function () {});
  }

  // Delegated, capture-phase so it runs before the browse-limit counter below
  // and survives header re-renders.
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest && e.target.closest('[data-pv-ads-cart]');
    if (!cartLink) return;
    // Let modified clicks open the main cart in a new tab via the href.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    if (cartLink.getAttribute('aria-disabled') === 'true') return;
    goToMainWithCart(MAIN_CART_URL);
  }, true);

  applyCartLinks();
  refreshCartState();
  window.addEventListener('pageshow', refreshCartState);

  // ── Browse-limit counter — navigation link clicks ───────────────────────
  // After the threshold, send the visitor to the same page on the main domain,
  // merging the ads cart so nothing is stranded. Add-to-cart clicks also count,
  // but through the fetch intercept below (it's a button, not an <a>).
  document.addEventListener('click', function (e) {
    if (isBot()) return;
    // Bridge → ppc hop is free: clicks on a bridge page never count.
    if (onBridgePage()) { return; }
    // Cart links hand off through their own handler above.
    if (e.target.closest('[data-pv-ads-cart]')) return;
    // Algolia card clicks are already counted by the capture-phase listener in
    // algolia_custom_hooks.js — skip them here to avoid double-counting.
    if (e.target.closest('.ais-hit, .ais-Hits-item')) return;
    var anchor = e.target.closest('a');
    if (!anchor) return;
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var count = parseInt(localStorage.getItem('acnt') || '0', 10) + 1;
    localStorage.setItem('acnt', String(count));

    if (count >= threshold) {
      e.preventDefault();
      localStorage.setItem('acnt', '0');
      localStorage.removeItem(SOURCE_KEY);
      var dest = href.indexOf('http') === 0
        ? href.replace('ads-qa.powdervalley.com', 'powdervalley.myshopify.com')
              .replace('ads.powdervalley.com', 'www.powdervalley.com')
        : mainOrigin() + (href.charAt(0) === '/' ? '' : '/') + href;
      goToMainWithCart(dest);
    }
  });

  // ── Browse-limit counter — Algolia product-card clicks ──────────────────
  // Algolia (InstantSearch + Preact) re-renders hit cards constantly, which
  // strips any per-card listener — that's why a card click sometimes counted
  // nothing. A SINGLE delegated capture-phase listener on the document survives
  // every re-render (document is never replaced) and runs before Algolia's own
  // card handler. It counts a real click on a product card and, once the limit
  // is crossed, hands the ads cart off to the same product on the main domain.
  document.addEventListener('click', function (e) {
    if (isBot()) return;
    // Bridge → ppc hop is free.
    if (onBridgePage()) { return; }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    // Algolia dispatches a SYNTHETIC click on the title <a> when you click the
    // non-link card area; skipping untrusted events avoids double-counting.
    if (!e.isTrusted) return;
    var card = e.target.closest && e.target.closest('.ais-hit, .ais-Hits-item');
    if (!card) return;
    // Cart links inside a card hand off through their own handler above.
    if (e.target.closest('[data-pv-ads-cart]')) return;

    var count = parseInt(localStorage.getItem('acnt') || '0', 10) + 1;
    localStorage.setItem('acnt', String(count));

    if (count >= threshold) {
      e.preventDefault();
      e.stopPropagation();
      localStorage.setItem('acnt', '0');
      localStorage.removeItem(SOURCE_KEY);
      var link = e.target.closest('a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      var href = link && link.getAttribute('href');
      if (href && href !== '#') {
        var dest = href.indexOf('http') === 0
          ? href.replace('ads-qa.powdervalley.com', 'powdervalley.myshopify.com')
                .replace('ads.powdervalley.com', 'www.powdervalley.com')
          : mainOrigin() + (href.charAt(0) === '/' ? '' : '/') + href;
        goToMainWithCart(dest);
      }
    }
  }, true);

  // ── Add-to-cart counts as a click too ────────────────────────────────────
  // ATC always adds to the ads cart and also counts toward the browse limit, so
  // a visitor who only adds items still gets funneled to the main store. The add
  // that crosses the limit sends the whole ads cart to the main domain (merged),
  // landing on the same page (the PDP) — not the cart page.
  var _fetch = window.fetch;
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url);
    var isAtc = url && url.includes('/cart/add') && options && options.method === 'POST';
    if (isAtc && !isBot()) {
      var result = _fetch.apply(this, arguments); // add to the ads cart
      // Only react to a successful add: fetch resolves on 422 too, so check .ok
      // (not the body) or a failed add would be counted and hand off empty.
      var onAddSuccess = function (handler) {
        result.then(function (response) {
          if (response && response.ok) handler();
        }, function () { /* network error — leave it to the theme */ });
      };
      // Bridge → ppc hop is free: ATC on a bridge page adds to the cart but does
      // not count toward the browse limit. (Still unlock the cart icon.)
      if (onBridgePage()) {
        onAddSuccess(function () { pvAdsCartHasItems = true; applyCartLinks(); });
        return result;
      }
      // Defer the count + hand-off until we know the add succeeded.
      onAddSuccess(function () {
        var count = parseInt(localStorage.getItem('acnt') || '0', 10) + 1;
        localStorage.setItem('acnt', String(count));
        if (count >= threshold) {
          localStorage.setItem('acnt', '0');
          localStorage.removeItem(SOURCE_KEY);
          var dest = mainOrigin() + window.location.pathname + window.location.search;
          // Crossing the limit on an add-to-cart: hand the whole ads cart to the
          // same PDP on the main domain and open the cart drawer there.
          goToMainWithCart(dest, true);
        } else {
          // Below the limit the add just lands in the ads cart; unlock the cart
          // icon now that there is something in it. (The theme's native cart-icon
          // updates the bubble on its own cart:update handling.)
          pvAdsCartHasItems = true;
          applyCartLinks();
        }
      });
      return result;
    }
    return _fetch.apply(this, arguments);
  };
})();
